export const maxString = (str, maxChars, showEllipses = true) => {
  if (str && str.length > maxChars)
    return str.substring(0, maxChars) + (showEllipses ? '...' : '');
  else
    return str;
}

export const getTextWidth = (element, text) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const font = getFontFromElement(element);
  context.font = font; // Set the font to match your text
  return context.measureText(text).width; // Measure text width
}

const getFontFromElement = (element) => {
  const style = window.getComputedStyle(element);
  return `${style.fontSize} ${style.fontFamily}`;
}